import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import IAMContext, {IAM} from 'contexts/IAMContext';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface withIAMProps {
    iam: IAM;
}

export default function withIAM<T extends withIAMProps>(WrappedComponent: React.ComponentType<T>) {
    class WithIAM extends React.Component<Omit<T, keyof withIAMProps>> {
        static displayName = `withIAM(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = IAMContext;

        render() {
            return <WrappedComponent {...(this.props as T)} iam={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithIAM, WrappedComponent);
    return WithIAM;
}
